export enum TinStateEnum {
	EXISTING = 'EXISTING',
	PENDING = 'PENDING',
	NOT_APPLICABLE = 'NOT_APPLICABLE',
	NONE = 'NONE'
}
